import Vue from "vue";
import VueRouter from "vue-router";
import authLayout from "@/router/layouts/authLayout";
import mainLayout from "@/router/layouts/mainLayout";
import errorLayout from "@/router/layouts/errorLayout";
import beforeEachMiddleware from "@/router/beforeEachMiddleware";
import afterEachMiddleware from "@/router/afterEachMiddleware";
import staticLayout from "@/router/layouts/staticLayout";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes: [
    ...authLayout,
    ...errorLayout,
    ...mainLayout,
    ...staticLayout,
    {
      path: "*",
      redirect: "/404",
    },
  ],
  scrollBehavior(to, from) {
    if (to.path === from.path && to.name === from.name) {
      return;
    }

    if (document.querySelector(".top-menu")) {
      return { x: 0, y: 0 };
    }

    if (document.querySelector(".main-content")) {
      document.querySelector(".main-content").scrollIntoView();
    }
  },
});

router.beforeEach(beforeEachMiddleware);
router.afterEach(afterEachMiddleware);

export default router;
